
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("afBrg", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::28e818db41afcf6fce742cecb9d4361e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $776858abadb4b212$var$_react = $776858abadb4b212$var$_interopRequireDefault((parcelRequire("42omo")));

var $776858abadb4b212$var$_baseNew = $776858abadb4b212$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $776858abadb4b212$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiGenerativeAudioBriefing".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for Audio Briefings, a new feature launching within Confluence to help people develop an expanded awareness on a topic by generating AI-powered podcasts about their work.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $776858abadb4b212$var$AiGenerativeAudioBriefingIcon = (props)=>/*#__PURE__*/ $776858abadb4b212$var$_react.default.createElement($776858abadb4b212$var$_baseNew.default, Object.assign({
        name: "AiGenerativeAudioBriefingIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0c.97 0 1.88.2 2.72.55l-.24.09c-.52.19-.93.56-1.19 1.02A5.5 5.5 0 0 0 2.5 7v.71A2.5 2.5 0 0 1 6 10v3.08A1.92 1.92 0 0 1 4.08 15 3.08 3.08 0 0 1 1 12V7a7 7 0 0 1 7-7M3.5 9a1 1 0 0 0-1 1v1.92c0 .87.71 1.58 1.58 1.58.23 0 .42-.19.42-.42V10a1 1 0 0 0-1-1m11.46-2.78Q15 6.6 15 7v5a3.08 3.08 0 0 1-3.08 3A1.92 1.92 0 0 1 10 13.08V10a2.5 2.5 0 0 1 3.5-2.29v-.73a2.25 2.25 0 0 0 1.46-.77M12.5 9a1 1 0 0 0-1 1v3.08c0 .23.19.42.42.42.87 0 1.58-.71 1.58-1.58V10a1 1 0 0 0-1-1" clip-rule="evenodd"/><path fill="currentcolor" d="M13.365.009a.75.75 0 0 1 .541.378l.05.106.334.92a.5.5 0 0 0 .298.297l.919.335a.75.75 0 0 1 0 1.41l-.92.335a.5.5 0 0 0-.297.298l-.335.919a.75.75 0 0 1-1.41 0l-.335-.92a.5.5 0 0 0-.298-.297l-.919-.335a.75.75 0 0 1-.484-.589L10.5 2.75l.009-.116a.75.75 0 0 1 .484-.59l.92-.334a.5.5 0 0 0 .297-.298l.335-.919A.75.75 0 0 1 13.249 0z"/>`
    }, props));
$776858abadb4b212$var$AiGenerativeAudioBriefingIcon.displayName = 'AiGenerativeAudioBriefingIcon';
var $776858abadb4b212$var$_default = module.exports.default = $776858abadb4b212$var$AiGenerativeAudioBriefingIcon;

});

parcelRegister("aVEh3", function(module, exports) {
/**
 * TODO: Once briefings V1 is removed, we can rename this file to `useAudio` so that it is more feature-agnostic.
 *
 * The reason we are not renaming it now is to reduce friction with the existing Briefings V1 feature
 * and thus just adding the activeFeature state and actions here.
 *
 * Once Briefings V1 is removed, we can update the name of this hook and also add a discriminated union
 * for all audio types and export feature specific hooks that converge onto the new `useAudio` hook.
 *
 * Part of reason we are not building on the new hook now is because some of the existing subcomponents
 * such as ToneSelector are used by both Briefings V1 and V2, so introduceing a new hook would mean that
 * these subcomponents would need to be either duplicated or call two state hooks.
 */ 
var $9zUhf = parcelRequire("9zUhf");

var $FOT9i = parcelRequire("FOT9i");

var $1P1Tu = parcelRequire("1P1Tu");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $f7B1p = parcelRequire("f7B1p");

const $a8c440a68b7f1d7a$export$b74ed40f1201d575 = '/gateway/api/v1/audio/summary';
const $a8c440a68b7f1d7a$export$6cb88531520814ca = '/gateway/api/v1/audio/narration';
const $a8c440a68b7f1d7a$export$6cea0b5571f5494d = '/gateway/api/v1/audio/briefing';
const $a8c440a68b7f1d7a$export$dae6df74caa4c21f = '/gateway/api/v1/audio/briefing/popular';
const $a8c440a68b7f1d7a$export$d12c91205ffb6498 = async ({ pageAri: pageAri, locale: locale, activationId: activationId })=>{
    const response = await (0, $f7B1p.cfetch)($a8c440a68b7f1d7a$export$b74ed40f1201d575, {
        method: 'POST',
        body: JSON.stringify({
            resource_ari: pageAri,
            locale: locale
        }),
        headers: {
            'Content-Type': 'application/json',
            'ATL-ActivationId': activationId
        }
    });
    if (!response.body) throw new Error('Response body is null');
    return response.body;
};
const $a8c440a68b7f1d7a$export$98358e5f5de55fe1 = async ({ activeContentAri: activeContentAri, locale: locale, activationId: activationId })=>{
    const response = await (0, $f7B1p.cfetch)($a8c440a68b7f1d7a$export$6cb88531520814ca, {
        method: 'POST',
        body: JSON.stringify({
            resource_ari: activeContentAri,
            locale: locale,
            transcriber_model: 'TEXT_ONLY'
        }),
        headers: {
            'Content-Type': 'application/json',
            'ATL-ActivationId': activationId
        }
    });
    if (!response.body) throw new Error('Response body is null');
    return response.body;
};
const $a8c440a68b7f1d7a$export$376975d31f493b5f = async ({ activeContentAri: activeContentAri, additionalResources: additionalResources, locale: locale, activationId: activationId, customization: customization })=>{
    const additionalResourcesBody = additionalResources.map((resource)=>({
            resource_ari: resource.ari,
            activation_id: activationId
        }));
    const response = await (0, $f7B1p.cfetch)($a8c440a68b7f1d7a$export$6cea0b5571f5494d, {
        method: 'POST',
        body: JSON.stringify({
            resources: [
                {
                    resource_ari: activeContentAri,
                    activation_id: activationId
                },
                ...additionalResourcesBody
            ],
            locale: locale,
            user_instruction: customization
        }),
        headers: {
            'Content-Type': 'application/json',
            'ATL-ActivationId': activationId
        }
    });
    if (!response.body) throw new Error('Response body is null');
    return response.body;
};
const $a8c440a68b7f1d7a$export$fad8b3947c9aadf = async (activationId, locale, customization)=>{
    const response = await (0, $f7B1p.cfetch)($a8c440a68b7f1d7a$export$dae6df74caa4c21f, {
        method: 'POST',
        body: JSON.stringify({
            locale: locale,
            user_instruction: customization
        }),
        headers: {
            'Content-Type': 'application/json',
            'ATL-ActivationId': activationId
        }
    });
    if (!response.body) throw new Error('Response body is null');
    return response.body;
};



var $3KEcv = parcelRequire("3KEcv");


var $f6lSf = parcelRequire("f6lSf");


var $7LiF4 = parcelRequire("7LiF4");


var $iqGoX = parcelRequire("iqGoX");


var $hBkCm = parcelRequire("hBkCm");




const $e183ec8972c1b3cf$export$5f39437091559ad1 = async (error)=>{
    if (error instanceof (0, $hBkCm.BadStatusError)) try {
        const response = error.response.clone();
        const errorData = await response.json();
        if (errorData.error?.includes('minimum context requirements')) return (0, $iqGoX.AudioBriefingError).CONTENT_TOO_SHORT;
    } catch (parseError) {
    // If error doesn't have response, or parsing fails, treat as general-error
    }
    return (0, $iqGoX.AudioBriefingError).GENERAL_ERROR;
};


const $383af3bced28b02d$var$DEFAULT_CUSTOMIZATION = {
    tone: (0, $3KEcv.CustomTone).PROFESSIONAL,
    length: (0, $3KEcv.CustomLength).SHORT
};
const $383af3bced28b02d$var$DEFAULT_PLAYBACK_SPEED = 1;
const $383af3bced28b02d$var$safeParseJson = (json)=>{
    try {
        return JSON.parse(json);
    } catch (e) {
        return $383af3bced28b02d$var$DEFAULT_CUSTOMIZATION;
    }
};
const $383af3bced28b02d$var$_performFeatureFetch = async (feature, req)=>{
    switch(feature){
        case (0, $7LiF4.AudioFeature).BRIEFING:
            {
                const stream = await (0, $a8c440a68b7f1d7a$export$376975d31f493b5f)(req);
                return {
                    stream: stream,
                    patch: {
                        lastGeneratedBriefingConfig: {
                            additionalResources: req.additionalResources,
                            customization: req.customization
                        }
                    }
                };
            }
        case (0, $7LiF4.AudioFeature).NARRATION:
            {
                const stream = await (0, $a8c440a68b7f1d7a$export$98358e5f5de55fe1)(req);
                return {
                    stream: stream,
                    patch: {}
                };
            }
        default:
            throw new Error('Unsupported audio feature');
    }
};
const $383af3bced28b02d$var$initialAudioBriefingState = {
    activeContent: undefined,
    activeFeature: undefined,
    customization: $383af3bced28b02d$var$DEFAULT_CUSTOMIZATION,
    additionalResources: [],
    cloudId: '',
    activationId: '',
    locale: 'en-US',
    isLoading: false,
    isPlaying: false,
    isClosed: false,
    isEnded: false,
    hasEndBeenReached: false,
    hasFetched: false,
    lastGeneratedBriefingConfig: undefined,
    playbackSpeed: $383af3bced28b02d$var$DEFAULT_PLAYBACK_SPEED,
    stream: undefined,
    error: undefined,
    errorType: undefined,
    streamEnded: false,
    requestKey: 0
};
const $383af3bced28b02d$export$924be06a1d1cfd91 = {
    initialize: (initialState)=>async ({ setState: setState })=>{
            const storedCustomization = (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).AI_AUDIO_BRIEFING_CUSTOMIZATION);
            const parsedCustomization = storedCustomization ? $383af3bced28b02d$var$safeParseJson(storedCustomization) : $383af3bced28b02d$var$DEFAULT_CUSTOMIZATION;
            const emptyAudioBriefingState = {
                stream: undefined,
                streamEnded: false,
                activeContent: undefined,
                activeFeature: undefined,
                customization: parsedCustomization,
                additionalResources: [],
                locale: 'en-US',
                cloudId: '',
                activationId: '',
                isLoading: false,
                isPlaying: false,
                isClosed: false,
                isEnded: false,
                hasEndBeenReached: false,
                hasFetched: false,
                error: undefined,
                errorType: undefined,
                playbackSpeed: Number((0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).AI_AUDIO_PLAYBACK_SPEED)) || $383af3bced28b02d$var$DEFAULT_PLAYBACK_SPEED,
                requestKey: 0
            };
            setState(Object.assign(emptyAudioBriefingState, initialState));
        },
    reset: ()=>({ setState: setState })=>{
            setState($383af3bced28b02d$var$initialAudioBriefingState);
        },
    _invalidateInFlightRequests: ()=>({ getState: getState, setState: setState })=>{
            const { requestKey: requestKey } = getState();
            setState({
                requestKey: (requestKey ?? 0) + 1
            });
        },
    addAdditionalResource: (newAdditionalResource)=>({ getState: getState, setState: setState })=>{
            const { additionalResources: additionalResources } = getState();
            setState({
                additionalResources: [
                    ...additionalResources,
                    newAdditionalResource
                ]
            });
        },
    removeAdditionalResource: (ariToRemove)=>({ getState: getState, setState: setState })=>{
            const { additionalResources: additionalResources } = getState();
            const newResourcesList = additionalResources.filter((resource)=>resource.ari !== ariToRemove);
            setState({
                additionalResources: newResourcesList
            });
        },
    fetchBriefing: ()=>async ({ dispatch: dispatch })=>{
            dispatch($383af3bced28b02d$export$924be06a1d1cfd91.fetchAudio({
                feature: (0, $7LiF4.AudioFeature).BRIEFING
            }));
        },
    fetchNarration: ()=>async ({ dispatch: dispatch })=>{
            dispatch($383af3bced28b02d$export$924be06a1d1cfd91.fetchAudio({
                feature: (0, $7LiF4.AudioFeature).NARRATION
            }));
        },
    fetchAudio: ({ feature: feature })=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
            dispatch($383af3bced28b02d$export$924be06a1d1cfd91.onLoadStart(feature));
            const { requestKey: capturedRequestKey, activeContent: activeContent, additionalResources: additionalResources, cloudId: cloudId, activationId: activationId, locale: locale, customization: customization } = getState();
            if (!activeContent) {
                dispatch($383af3bced28b02d$export$924be06a1d1cfd91.setContentError(new Error('Briefing container needs to be initialized')));
                return;
            }
            const activeContentAri = (0, $f6lSf.getConfluenceContentAri)(cloudId, activeContent.id, activeContent.contentType);
            if (!activeContentAri) {
                dispatch($383af3bced28b02d$export$924be06a1d1cfd91.setContentError(new Error('Content ARI failed to generate')));
                return;
            }
            const isStale = ()=>getState().requestKey !== capturedRequestKey;
            try {
                const apiRequest = {
                    activeContentAri: activeContentAri,
                    additionalResources: additionalResources,
                    activationId: activationId,
                    locale: locale,
                    customization: customization
                };
                const { stream: stream, patch: patch } = await $383af3bced28b02d$var$_performFeatureFetch(feature, apiRequest);
                if (isStale() || getState().isClosed) return;
                setState({
                    isPlaying: false,
                    isEnded: false,
                    hasEndBeenReached: false,
                    stream: stream,
                    ...patch
                });
            } catch (e) {
                if (isStale()) return;
                const errorType = await (0, $e183ec8972c1b3cf$export$5f39437091559ad1)(e);
                setState({
                    error: e,
                    errorType: errorType,
                    stream: undefined
                });
            } finally{
                if (!isStale()) dispatch($383af3bced28b02d$export$924be06a1d1cfd91.onLoadEnd());
            }
        },
    onLoadStart: (feature)=>({ setState: setState, dispatch: dispatch })=>{
            dispatch($383af3bced28b02d$export$924be06a1d1cfd91._invalidateInFlightRequests());
            setState({
                activeFeature: feature,
                isLoading: true,
                hasFetched: true,
                error: undefined,
                errorType: undefined,
                streamEnded: false
            });
        },
    onLoadEnd: ()=>({ setState: setState })=>{
            setState({
                isLoading: false
            });
        },
    pauseContent: ()=>({ setState: setState })=>{
            setState({
                isPlaying: false
            });
        },
    resumeContent: ()=>({ setState: setState, getState: getState })=>{
            const { stream: stream } = getState();
            if (!stream) throw new Error('Must fetch before playing');
            setState({
                isPlaying: true,
                isEnded: false
            });
        },
    setContentPlaybackSpeed: (speed)=>({ setState: setState })=>{
            (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).AI_AUDIO_PLAYBACK_SPEED, speed);
            setState({
                playbackSpeed: speed
            });
        },
    stopContent: ()=>async ({ dispatch: dispatch, setState: setState })=>{
            dispatch($383af3bced28b02d$export$924be06a1d1cfd91.reset());
            setState({
                isClosed: true
            });
        },
    endContent: ()=>({ setState: setState })=>{
            setState({
                isEnded: true,
                hasEndBeenReached: true,
                isPlaying: false
            });
        },
    setContentError: (error)=>({ setState: setState })=>{
            setState({
                error: error,
                errorType: (0, $iqGoX.AudioBriefingError).GENERAL_ERROR
            });
        },
    setStreamEnded: (streamEnded)=>({ setState: setState })=>{
            setState({
                streamEnded: streamEnded
            });
        },
    setCustomization: (newCustomization)=>({ setState: setState, getState: getState })=>{
            const { customization: customization } = getState();
            const updatedCustomization = {
                ...customization,
                ...newCustomization
            };
            (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).AI_AUDIO_BRIEFING_CUSTOMIZATION, JSON.stringify({
                tone: updatedCustomization.tone,
                length: updatedCustomization.length
            }));
            setState({
                customization: updatedCustomization
            });
        }
};
const $383af3bced28b02d$export$390f32400eaf98c9 = (0, $1P1Tu.createStore)({
    initialState: {
        activeContent: undefined,
        customization: $383af3bced28b02d$var$DEFAULT_CUSTOMIZATION,
        additionalResources: [],
        cloudId: '',
        activationId: '',
        locale: 'en-US',
        isLoading: false,
        isPlaying: false,
        isClosed: false,
        isEnded: false,
        hasEndBeenReached: false,
        hasFetched: false,
        playbackSpeed: 1,
        error: undefined,
        errorType: undefined,
        streamEnded: false,
        requestKey: 0
    },
    actions: $383af3bced28b02d$export$924be06a1d1cfd91,
    name: 'listenerState'
});
const $383af3bced28b02d$export$ff3c0e7d5b0100a7 = (0, $FOT9i.createContainer)($383af3bced28b02d$export$390f32400eaf98c9, {
    onInit: ()=>async ({ dispatch: dispatch }, { initialAudioBriefingState: initialAudioPlaybackState })=>{
            dispatch($383af3bced28b02d$export$924be06a1d1cfd91.initialize(initialAudioPlaybackState));
        }
});
const $383af3bced28b02d$export$5f4418f41c33b771 = (0, $9zUhf.createHook)($383af3bced28b02d$export$390f32400eaf98c9);
const $383af3bced28b02d$export$722396384dacf938 = (0, $9zUhf.createActionsHook)($383af3bced28b02d$export$390f32400eaf98c9);
module.exports["useAudioBriefing"] = $383af3bced28b02d$export$5f4418f41c33b771;

});

parcelRegister("3KEcv", function(module, exports) {
const $6babaf5010ad9ae0$export$22914fe597403470 = {
    PLAYFUL: 'playful',
    PROFESSIONAL: 'professional',
    CONVERSATIONAL: 'conversational',
    SURPRISE: 'surprise'
};
const $6babaf5010ad9ae0$export$91791b32a6f45c02 = {
    SHORT: 'short',
    MEDIUM: 'medium',
    LONG: 'long'
};
module.exports["CustomTone"] = $6babaf5010ad9ae0$export$22914fe597403470;
module.exports["CustomLength"] = $6babaf5010ad9ae0$export$91791b32a6f45c02;

});

parcelRegister("f6lSf", function(module, exports) {

var $eB56w = parcelRequire("eB56w");

var $a2xFu = parcelRequire("a2xFu");

var $a5Dk4 = parcelRequire("a5Dk4");

const $f16877b6875ebf37$export$6a2f2c83863e9bfe = (siteId, contentId, contentType)=>{
    try {
        switch(contentType){
            case 'page':
                return (0, $a2xFu.ConfluencePageAri).create({
                    siteId: siteId,
                    pageId: contentId
                });
            case 'blogpost':
                return (0, $eB56w.ConfluenceBlogpostAri).create({
                    siteId: siteId,
                    blogpostId: contentId
                });
            case 'whiteboard':
                return (0, $a5Dk4.ConfluenceWhiteboardAri).create({
                    siteId: siteId,
                    whiteboardId: contentId
                });
        }
    } catch  {
        return undefined;
    }
    return undefined;
};
module.exports["getConfluenceContentAri"] = $f16877b6875ebf37$export$6a2f2c83863e9bfe;

});

parcelRegister("7LiF4", function(module, exports) {
const $06aae44591cf448a$export$ae7d97a50b8bcedb = {
    BRIEFING: 'briefing',
    NARRATION: 'narration'
};
module.exports["AudioFeature"] = $06aae44591cf448a$export$ae7d97a50b8bcedb;

});

parcelRegister("iqGoX", function(module, exports) {
const $9970821b1217563d$export$9d929f8d0507419c = {
    CONTENT_TOO_SHORT: 'content-too-short',
    GENERAL_ERROR: 'general-error'
};
module.exports["AudioBriefingError"] = $9970821b1217563d$export$9d929f8d0507419c;

});

parcelRegister("52Sgp", function(module, exports) {

var $iXzFq = parcelRequire("iXzFq");

const $f8dae92e82bbcfd5$export$aab6a07214727b65 = (audioContent1, audioContent2)=>{
    return audioContent1.id === audioContent2.id && audioContent1.spaceKey === audioContent2.spaceKey && audioContent1.contentType === audioContent2.contentType && audioContent1.sourceType === audioContent2.sourceType;
};
const $f8dae92e82bbcfd5$export$f60f45b8c8af98e4 = (activeAudioContent)=>{
    return !!activeAudioContent.id && !!activeAudioContent.spaceKey && !!activeAudioContent.contentType;
};


const $fc8507f52b4402cb$var$getOrigin = ()=>{
    return window.location.hostname === 'localhost' ? `https://${window.__backendOriginHost}` : window.location.origin;
};
const $fc8507f52b4402cb$export$701669137e89de62 = (activeContent)=>{
    if ((0, $f8dae92e82bbcfd5$export$f60f45b8c8af98e4)(activeContent)) {
        const contentPath = (0, $iXzFq.getUrlForContentType)({
            contentType: activeContent.contentType,
            contentId: activeContent.id,
            // @ts-ignore Checked by above conditional
            spaceKey: activeContent.spaceKey
        });
        return `${$fc8507f52b4402cb$var$getOrigin()}${contentPath}`;
    }
    return null;
};
module.exports["getContentUrl"] = $fc8507f52b4402cb$export$701669137e89de62;

});

parcelRegister("9s8in", function(module, exports) {

var $lbhE8 = parcelRequire("lbhE8");


var $lqUMo = parcelRequire("lqUMo");

const $4adad3a8665dccf2$export$cba1cb68876d4742 = ()=>{
    const state = (0, $lbhE8.useAtom)((0, $lqUMo.audioPlayerState));
    return {
        // State
        isOpen: state.isOpen,
        isPlaying: state.isPlaying,
        isPaused: state.isPaused,
        activeContent: state.activeContent,
        activeFeature: state.activeFeature,
        activeMenu: state.activeMenu,
        activeAudioContainerMode: state.activeAudioContainerMode,
        pendingContent: state.pendingContent,
        cloudId: state.cloudId,
        customization: state.customization,
        openAudioPlayer: // Actions
        $lqUMo.openAudioPlayer,
        closeAudioPlayer: $lqUMo.closeAudioPlayer,
        activatePendingContent: $lqUMo.activatePendingContent,
        clearPendingContent: $lqUMo.clearPendingContent,
        setIsPlaying: $lqUMo.setIsPlaying,
        setIsPaused: $lqUMo.setIsPaused,
        updatePlayerState: $lqUMo.updatePlayerState,
        setActiveFeature: $lqUMo.setActiveFeature,
        setActiveMenu: $lqUMo.setActiveMenu,
        setActiveAudioContainerMode: $lqUMo.setActiveAudioContainerMode,
        setCustomization: $lqUMo.setCustomization,
        getCustomization: $lqUMo.getCustomization,
        setPlaybackSpeed: $lqUMo.setPlaybackSpeed,
        getSupportingContent: $lqUMo.getSupportingContent,
        setSupportingContent: $lqUMo.setSupportingContent
    };
};
module.exports["useAudioPlayerStore"] = $4adad3a8665dccf2$export$cba1cb68876d4742;

});

parcelRegister("lqUMo", function(module, exports) {

var $9TRAA = parcelRequire("9TRAA");


var $CAM5Y = parcelRequire("CAM5Y");


var $61eRd = parcelRequire("61eRd");

const $7698e90cebff2064$var$DEFAULT_AUDIO_FEATURE = (0, $CAM5Y.AudioFeatureType).BRIEFING;
const $7698e90cebff2064$var$DEFAULT_CUSTOMIZATION = {
    tone: 'PROFESSIONAL',
    length: 'SHORT',
    playbackSpeed: 1.0
};
const $7698e90cebff2064$var$initialState = {
    activeContent: {
        contentId: '',
        spaceKey: '',
        contentType: '',
        subType: '',
        title: '',
        author: '',
        avatarUrl: '',
        supportingContent: [],
        mainContentLink: '',
        emojiId: undefined
    },
    activeFeature: $7698e90cebff2064$var$DEFAULT_AUDIO_FEATURE,
    activeAudioContainerMode: (0, $61eRd.AUDIO_CONTAINER_MODES).EXPANDED,
    pendingContent: null,
    isOpen: false,
    isPlaying: false,
    isPaused: false,
    product: '',
    cloudId: '',
    activationId: '',
    customization: $7698e90cebff2064$var$DEFAULT_CUSTOMIZATION
};
const $7698e90cebff2064$export$cdbb2fdff9747f37 = (0, $9TRAA.e)($7698e90cebff2064$var$initialState);
const $7698e90cebff2064$export$4bf748e973a0a732 = (activeContent)=>{
    $7698e90cebff2064$export$cdbb2fdff9747f37.set((prevState)=>({
            ...prevState,
            activeContent: activeContent,
            // Reset playback states when switching to a new track
            isPlaying: false,
            isPaused: false
        }));
};
const $7698e90cebff2064$export$30d2a851f8b14636 = (activeFeature)=>{
    $7698e90cebff2064$export$cdbb2fdff9747f37.set((prevState)=>({
            ...prevState,
            activeFeature: activeFeature
        }));
};
const $7698e90cebff2064$export$fa9442b044bf53f8 = (activeMenu)=>{
    $7698e90cebff2064$export$cdbb2fdff9747f37.set((prevState)=>({
            ...prevState,
            activeMenu: activeMenu
        }));
};
const $7698e90cebff2064$export$8ce6f8a1db2bbc43 = (activeAudioContainerMode)=>{
    $7698e90cebff2064$export$cdbb2fdff9747f37.set((prevState)=>({
            ...prevState,
            activeAudioContainerMode: activeAudioContainerMode
        }));
};
const $7698e90cebff2064$export$dfa73cfe44e75105 = (contentToOpen, options)=>{
    $7698e90cebff2064$export$cdbb2fdff9747f37.set((prevState)=>{
        // Check if the content is already active
        const isAlreadyActive = prevState.activeContent.contentId === contentToOpen.contentId;
        // Check if the content is already pending
        const isAlreadyPending = prevState.pendingContent?.contentId === contentToOpen.contentId;
        // If content is already active or pending, do nothing
        if (isAlreadyActive || isAlreadyPending) return prevState;
        // If the player is uninitialized, set the new content as active
        if (options?.isUninitialized) return {
            ...prevState,
            activeContent: contentToOpen,
            isOpen: true
        };
        // If player is already open, set new content as pending
        if (prevState.isOpen) return {
            ...prevState,
            pendingContent: contentToOpen
        };
        // Otherwise, set as active content and open player
        return {
            ...prevState,
            activeContent: contentToOpen,
            isOpen: true
        };
    });
};
const $7698e90cebff2064$export$dba664cdc5e8fbf4 = ()=>{
    $7698e90cebff2064$export$cdbb2fdff9747f37.set((prevState)=>{
        if (prevState.pendingContent) return {
            ...prevState,
            activeContent: prevState.pendingContent,
            pendingContent: null,
            isPlaying: false,
            isPaused: false
        };
        return prevState;
    });
};
const $7698e90cebff2064$export$feb15da72003eb0f = ()=>{
    $7698e90cebff2064$export$cdbb2fdff9747f37.set((prevState)=>({
            ...prevState,
            pendingContent: null
        }));
};
const $7698e90cebff2064$export$c7e4afd074cdd19a = ()=>{
    $7698e90cebff2064$export$cdbb2fdff9747f37.set($7698e90cebff2064$var$initialState);
};
const $7698e90cebff2064$export$92debfee183fcd0e = (isPlaying)=>{
    $7698e90cebff2064$export$cdbb2fdff9747f37.set((prevState)=>({
            ...prevState,
            isPlaying: isPlaying
        }));
};
const $7698e90cebff2064$export$8e7c7df046bd1f47 = (isPaused)=>{
    $7698e90cebff2064$export$cdbb2fdff9747f37.set((prevState)=>({
            ...prevState,
            isPaused: isPaused
        }));
};
const $7698e90cebff2064$export$36bd232e206b82e1 = (updates)=>{
    $7698e90cebff2064$export$cdbb2fdff9747f37.set((prevState)=>({
            ...prevState,
            ...updates
        }));
};
const $7698e90cebff2064$export$5163deecba0c25e4 = (newCustomization)=>{
    $7698e90cebff2064$export$cdbb2fdff9747f37.set((prevState)=>{
        const { customization: customization } = prevState;
        const updatedCustomization = {
            ...customization,
            ...newCustomization
        };
        return {
            ...prevState,
            customization: updatedCustomization
        };
    });
};
const $7698e90cebff2064$export$c690cb8c8df11c13 = ()=>{
    return $7698e90cebff2064$export$cdbb2fdff9747f37.get().customization;
};
const $7698e90cebff2064$export$c51fb0a0341d4b0 = (supportingContent)=>{
    $7698e90cebff2064$export$cdbb2fdff9747f37.set((prevState)=>({
            ...prevState,
            activeContent: {
                ...prevState.activeContent,
                supportingContent: supportingContent
            }
        }));
};
const $7698e90cebff2064$export$ef9379a59560cce = ()=>{
    return $7698e90cebff2064$export$cdbb2fdff9747f37.get().activeContent.supportingContent;
};
const $7698e90cebff2064$export$850d40cfba439ef9 = (playbackSpeed)=>{
    $7698e90cebff2064$export$cdbb2fdff9747f37.set((prevState)=>({
            ...prevState,
            customization: {
                ...prevState.customization,
                playbackSpeed: playbackSpeed
            }
        }));
};
module.exports["audioPlayerState"] = $7698e90cebff2064$export$cdbb2fdff9747f37;
module.exports["setActiveContent"] = $7698e90cebff2064$export$4bf748e973a0a732;
module.exports["setActiveFeature"] = $7698e90cebff2064$export$30d2a851f8b14636;
module.exports["setActiveMenu"] = $7698e90cebff2064$export$fa9442b044bf53f8;
module.exports["setActiveAudioContainerMode"] = $7698e90cebff2064$export$8ce6f8a1db2bbc43;
module.exports["openAudioPlayer"] = $7698e90cebff2064$export$dfa73cfe44e75105;
module.exports["activatePendingContent"] = $7698e90cebff2064$export$dba664cdc5e8fbf4;
module.exports["clearPendingContent"] = $7698e90cebff2064$export$feb15da72003eb0f;
module.exports["closeAudioPlayer"] = $7698e90cebff2064$export$c7e4afd074cdd19a;
module.exports["setIsPlaying"] = $7698e90cebff2064$export$92debfee183fcd0e;
module.exports["setIsPaused"] = $7698e90cebff2064$export$8e7c7df046bd1f47;
module.exports["updatePlayerState"] = $7698e90cebff2064$export$36bd232e206b82e1;
module.exports["setCustomization"] = $7698e90cebff2064$export$5163deecba0c25e4;
module.exports["getCustomization"] = $7698e90cebff2064$export$c690cb8c8df11c13;
module.exports["setSupportingContent"] = $7698e90cebff2064$export$c51fb0a0341d4b0;
module.exports["getSupportingContent"] = $7698e90cebff2064$export$ef9379a59560cce;
module.exports["setPlaybackSpeed"] = $7698e90cebff2064$export$850d40cfba439ef9;

});

parcelRegister("CAM5Y", function(module, exports) {
var $53b8f68bbadfad1e$export$1e95f84c3271729c = /*#__PURE__*/ function(AudioFeatureType) {
    AudioFeatureType["BRIEFING"] = "briefing";
    AudioFeatureType["NARRATION"] = "narration";
    return AudioFeatureType;
}({});
module.exports["AudioFeatureType"] = $53b8f68bbadfad1e$export$1e95f84c3271729c;

});

parcelRegister("61eRd", function(module, exports) {
const $d424d10c3c8d920b$export$f14c697305877ebc = {
    EXPANDED: {
        name: 'expanded',
        width: 380
    },
    MINIFIED: {
        name: 'minified',
        width: 274
    }
};
module.exports["AUDIO_CONTAINER_MODES"] = $d424d10c3c8d920b$export$f14c697305877ebc;

});

parcelRegister("4wsPv", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $lbhE8 = parcelRequire("lbhE8");


var $aU1TP = parcelRequire("aU1TP");

const $441d910c6d0db13d$export$9ea8ebe6968f73b1 = ()=>{
    const state = (0, $lbhE8.useAtom)((0, $aU1TP.audioPlayerStreamingStore));
    const updateAudioPlayerStreamingStore = (0, $42omo.useCallback)((action)=>{
        (0, $aU1TP.setAudioPlayerStreamingStore)(action);
    }, []);
    return {
        state: state,
        updateAudioPlayerStreamingStore: updateAudioPlayerStreamingStore
    };
};
module.exports["useAudioPlayerStreamingStore"] = $441d910c6d0db13d$export$9ea8ebe6968f73b1;

});

parcelRegister("aU1TP", function(module, exports) {

var $9TRAA = parcelRequire("9TRAA");

var $ae4e7949267550f2$export$eb3237121301a5e5 = /*#__PURE__*/ function(AudioStreamingState) {
    AudioStreamingState["UNINITIALIZED"] = "uninitialized";
    AudioStreamingState["LOADING"] = "loading";
    AudioStreamingState["ERROR"] = "error";
    AudioStreamingState["STREAM_STARTED"] = "stream_started";
    AudioStreamingState["STREAM_DISPOSED"] = "stream_disposed";
    return AudioStreamingState;
}({});
const $ae4e7949267550f2$export$a0ed58682f50d27c = (0, $9TRAA.e)({
    state: "uninitialized"
});
const $ae4e7949267550f2$export$218145c33c4aee2e = (action)=>{
    switch(action.type){
        case "uninitialized":
            $ae4e7949267550f2$export$a0ed58682f50d27c.set({
                state: "uninitialized"
            });
            break;
        case "loading":
            $ae4e7949267550f2$export$a0ed58682f50d27c.set({
                state: "loading"
            });
            break;
        case "error":
            $ae4e7949267550f2$export$a0ed58682f50d27c.set({
                state: "error",
                error: action.error
            });
            break;
        case "stream_started":
            $ae4e7949267550f2$export$a0ed58682f50d27c.set({
                state: "stream_started",
                response: action.response
            });
            break;
        case "stream_disposed":
            $ae4e7949267550f2$export$a0ed58682f50d27c.set({
                state: "stream_disposed"
            });
            break;
    }
};
module.exports["AudioStreamingState"] = $ae4e7949267550f2$export$eb3237121301a5e5;
module.exports["audioPlayerStreamingStore"] = $ae4e7949267550f2$export$a0ed58682f50d27c;
module.exports["setAudioPlayerStreamingStore"] = $ae4e7949267550f2$export$218145c33c4aee2e;

});

parcelRegister("9TRAA", function(module, exports) {
/* eslint-disable */ function $7352d1cb7623abab$var$createReactiveSystem({ update: update, notify: notify, unwatched: unwatched }) {
    let currentVersion = 0;
    return {
        link: link,
        unlink: unlink,
        propagate: propagate,
        checkDirty: checkDirty,
        endTracking: endTracking,
        startTracking: startTracking,
        shallowPropagate: shallowPropagate
    };
    function link(dep, sub) {
        const prevDep = sub._depsTail;
        if (prevDep !== undefined && prevDep.dep === dep) return;
        const nextDep = prevDep !== undefined ? prevDep.nextDep : sub._deps;
        if (nextDep !== undefined && nextDep.dep === dep) {
            nextDep.version = currentVersion;
            sub._depsTail = nextDep;
            return;
        }
        const prevSub = dep._subsTail;
        if (prevSub !== undefined && prevSub.version === currentVersion && prevSub.sub === sub) return;
        const newLink = sub._depsTail = dep._subsTail = {
            version: currentVersion,
            dep: dep,
            sub: sub,
            prevDep: prevDep,
            nextDep: nextDep,
            prevSub: prevSub,
            nextSub: undefined
        };
        if (nextDep !== undefined) nextDep.prevDep = newLink;
        if (prevDep !== undefined) prevDep.nextDep = newLink;
        else sub._deps = newLink;
        if (prevSub !== undefined) prevSub.nextSub = newLink;
        else dep._subs = newLink;
    }
    function unlink(link, sub = link.sub) {
        const dep = link.dep;
        const prevDep = link.prevDep;
        const nextDep = link.nextDep;
        const nextSub = link.nextSub;
        const prevSub = link.prevSub;
        if (nextDep !== undefined) nextDep.prevDep = prevDep;
        else sub._depsTail = prevDep;
        if (prevDep !== undefined) prevDep.nextDep = nextDep;
        else sub._deps = nextDep;
        if (nextSub !== undefined) nextSub.prevSub = prevSub;
        else dep._subsTail = prevSub;
        if (prevSub !== undefined) prevSub.nextSub = nextSub;
        else if ((dep._subs = nextSub) === undefined) unwatched(dep);
        return nextDep;
    }
    function propagate(link) {
        let next = link.nextSub;
        let stack;
        top: do {
            const sub = link.sub;
            let flags = sub._flags;
            if (!(flags & 60)) sub._flags = flags | 32;
            else if (!(flags & 12)) flags = 0;
            else if (!(flags & 4)) sub._flags = flags & -9 | 32;
            else if (!(flags & 48) && isValidLink(link, sub)) {
                sub._flags = flags | 40;
                flags &= 1;
            } else flags = 0;
            if (flags & 2) notify(sub);
            if (flags & 1) {
                const subSubs = sub._subs;
                if (subSubs !== undefined) {
                    const nextSub = (link = subSubs).nextSub;
                    if (nextSub !== undefined) {
                        stack = {
                            value: next,
                            prev: stack
                        };
                        next = nextSub;
                    }
                    continue;
                }
            }
            if ((link = next) !== undefined) {
                next = link.nextSub;
                continue;
            }
            while(stack !== undefined){
                link = stack.value;
                stack = stack.prev;
                if (link !== undefined) {
                    next = link.nextSub;
                    continue top;
                }
            }
            break;
        }while (true);
    }
    function startTracking(sub) {
        ++currentVersion;
        sub._depsTail = undefined;
        sub._flags = sub._flags & -57 | 4;
    }
    function endTracking(sub) {
        const depsTail = sub._depsTail;
        let toRemove = depsTail !== undefined ? depsTail.nextDep : sub._deps;
        while(toRemove !== undefined)toRemove = unlink(toRemove, sub);
        sub._flags &= -5;
    }
    function checkDirty(link, sub) {
        let stack;
        let checkDepth = 0;
        top: do {
            const dep = link.dep;
            const flags = dep._flags;
            let dirty = false;
            if (sub._flags & 16) dirty = true;
            else if ((flags & 17) === 17) {
                if (update(dep)) {
                    const subs = dep._subs;
                    if (subs.nextSub !== undefined) shallowPropagate(subs);
                    dirty = true;
                }
            } else if ((flags & 33) === 33) {
                if (link.nextSub !== undefined || link.prevSub !== undefined) stack = {
                    value: link,
                    prev: stack
                };
                link = dep._deps;
                sub = dep;
                ++checkDepth;
                continue;
            }
            if (!dirty) {
                const nextDep = link.nextDep;
                if (nextDep !== undefined) {
                    link = nextDep;
                    continue;
                }
            }
            while(checkDepth--){
                const firstSub = sub._subs;
                const hasMultipleSubs = firstSub.nextSub !== undefined;
                if (hasMultipleSubs) {
                    link = stack.value;
                    stack = stack.prev;
                } else link = firstSub;
                if (dirty) {
                    if (update(sub)) {
                        if (hasMultipleSubs) shallowPropagate(firstSub);
                        sub = link.sub;
                        continue;
                    }
                } else sub._flags &= -33;
                sub = link.sub;
                const nextDep = link.nextDep;
                if (nextDep !== undefined) {
                    link = nextDep;
                    continue top;
                }
                dirty = false;
            }
            return dirty;
        }while (true);
    }
    function shallowPropagate(link) {
        do {
            const sub = link.sub;
            const flags = sub._flags;
            if ((flags & 48) === 32) {
                sub._flags = flags | 16;
                if (flags & 2) notify(sub);
            }
        }while ((link = link.nextSub) !== undefined);
    }
    function isValidLink(checkLink, sub) {
        let link = sub._depsTail;
        while(link !== undefined){
            if (link === checkLink) return true;
            link = link.prevDep;
        }
        return false;
    }
}
function $7352d1cb7623abab$var$toObserver(nextHandler, errorHandler, completionHandler) {
    const isObserver = typeof nextHandler === 'object';
    const self = isObserver ? nextHandler : undefined;
    return {
        next: (isObserver ? nextHandler.next : nextHandler)?.bind(self),
        error: (isObserver ? nextHandler.error : errorHandler)?.bind(self),
        complete: (isObserver ? nextHandler.complete : completionHandler)?.bind(self)
    };
}
const $7352d1cb7623abab$var$queuedEffects = [];
const { link: $7352d1cb7623abab$var$link, unlink: $7352d1cb7623abab$var$unlink, propagate: $7352d1cb7623abab$var$propagate, checkDirty: $7352d1cb7623abab$var$checkDirty, endTracking: $7352d1cb7623abab$var$endTracking, startTracking: $7352d1cb7623abab$var$startTracking, shallowPropagate: $7352d1cb7623abab$var$shallowPropagate } = $7352d1cb7623abab$var$createReactiveSystem({
    update (atom) {
        return atom._update();
    },
    notify (effect) {
        $7352d1cb7623abab$var$queuedEffects[$7352d1cb7623abab$var$queuedEffectsLength++] = effect;
    },
    unwatched (atom) {
        let toRemove = atom._deps;
        if (toRemove !== undefined) {
            atom._flags = 17;
            do toRemove = $7352d1cb7623abab$var$unlink(toRemove, atom);
            while (toRemove !== undefined);
        }
    }
});
let $7352d1cb7623abab$var$notifyIndex = 0;
let $7352d1cb7623abab$var$queuedEffectsLength = 0;
let $7352d1cb7623abab$var$activeSub;
function $7352d1cb7623abab$var$flush() {
    while($7352d1cb7623abab$var$notifyIndex < $7352d1cb7623abab$var$queuedEffectsLength){
        const effect = $7352d1cb7623abab$var$queuedEffects[$7352d1cb7623abab$var$notifyIndex];
        $7352d1cb7623abab$var$queuedEffects[$7352d1cb7623abab$var$notifyIndex++] = undefined;
        effect.notify();
    }
    $7352d1cb7623abab$var$notifyIndex = 0;
    $7352d1cb7623abab$var$queuedEffectsLength = 0;
}
function $7352d1cb7623abab$export$2d1720544b23b823(getValue, options) {
    const atom = $7352d1cb7623abab$export$f1e1789686576879(()=>{
        getValue().then((data)=>{
            if (atom._update({
                status: 'done',
                data: data
            })) {
                const subs = atom._subs;
                if (subs !== undefined) {
                    $7352d1cb7623abab$var$propagate(subs);
                    $7352d1cb7623abab$var$shallowPropagate(subs);
                    $7352d1cb7623abab$var$flush();
                }
            }
        }, (error)=>{
            if (atom._update({
                status: 'error',
                error: error
            })) {
                const subs = atom._subs;
                if (subs !== undefined) {
                    $7352d1cb7623abab$var$propagate(subs);
                    $7352d1cb7623abab$var$shallowPropagate(subs);
                    $7352d1cb7623abab$var$flush();
                }
            }
        });
        return {
            status: 'pending'
        };
    }, options);
    return atom;
}
function $7352d1cb7623abab$export$f1e1789686576879(valueOrFn, options) {
    const isComputed = typeof valueOrFn === 'function';
    const getter = valueOrFn;
    // Create plain object atom
    const atom = {
        _snapshot: isComputed ? undefined : valueOrFn,
        _subs: undefined,
        _subsTail: undefined,
        _flags: 0,
        get () {
            if ($7352d1cb7623abab$var$activeSub !== undefined) $7352d1cb7623abab$var$link(atom, $7352d1cb7623abab$var$activeSub);
            return atom._snapshot;
        },
        subscribe (observerOrFn) {
            const obs = $7352d1cb7623abab$var$toObserver(observerOrFn);
            const observed = {
                current: false
            };
            const e = $7352d1cb7623abab$var$effect(()=>{
                atom.get();
                if (!observed.current) observed.current = true;
                else obs.next?.(atom._snapshot);
            });
            return {
                unsubscribe: ()=>{
                    e.stop();
                }
            };
        },
        _update (getValue) {
            const prevSub = $7352d1cb7623abab$var$activeSub;
            const compare = options?.compare ?? Object.is;
            $7352d1cb7623abab$var$activeSub = atom;
            $7352d1cb7623abab$var$startTracking(atom);
            try {
                const oldValue = atom._snapshot;
                const read = (atom)=>atom.get();
                const newValue = typeof getValue === 'function' ? getValue(oldValue) : getValue === undefined && isComputed ? getter(read) : getValue;
                if (oldValue === undefined || !compare(oldValue, newValue)) {
                    atom._snapshot = newValue;
                    return true;
                }
                return false;
            } finally{
                $7352d1cb7623abab$var$activeSub = prevSub;
                $7352d1cb7623abab$var$endTracking(atom);
            }
        }
    };
    if (isComputed) Object.assign(atom, {
        _deps: undefined,
        _depsTail: undefined,
        _flags: 17,
        get () {
            const flags = this._flags;
            if (flags & 16 || flags & 32 && $7352d1cb7623abab$var$checkDirty(atom._deps, atom)) {
                if (atom._update()) {
                    const subs = atom._subs;
                    if (subs !== undefined) $7352d1cb7623abab$var$shallowPropagate(subs);
                }
            } else if (flags & 32) atom._flags = flags & -33;
            if ($7352d1cb7623abab$var$activeSub !== undefined) $7352d1cb7623abab$var$link(atom, $7352d1cb7623abab$var$activeSub);
            return atom._snapshot;
        }
    });
    else Object.assign(atom, {
        set (valueOrFn) {
            if (atom._update(valueOrFn)) {
                const subs = atom._subs;
                if (subs !== undefined) {
                    $7352d1cb7623abab$var$propagate(subs);
                    $7352d1cb7623abab$var$shallowPropagate(subs);
                    $7352d1cb7623abab$var$flush();
                }
            }
        }
    });
    return atom;
}
function $7352d1cb7623abab$var$effect(fn) {
    const run = ()=>{
        const prevSub = $7352d1cb7623abab$var$activeSub;
        $7352d1cb7623abab$var$activeSub = effectObj;
        $7352d1cb7623abab$var$startTracking(effectObj);
        try {
            return fn();
        } finally{
            $7352d1cb7623abab$var$activeSub = prevSub;
            $7352d1cb7623abab$var$endTracking(effectObj);
        }
    };
    const effectObj = {
        _deps: undefined,
        _depsTail: undefined,
        _flags: 2,
        notify () {
            const flags = this._flags;
            if (flags & 16 || flags & 32 && $7352d1cb7623abab$var$checkDirty(this._deps, this)) run();
            else if (flags & 32) this._flags = flags & -33;
        },
        stop () {
            $7352d1cb7623abab$var$startTracking(this);
            $7352d1cb7623abab$var$endTracking(this);
        }
    };
    run();
    return effectObj;
}
const $7352d1cb7623abab$var$symbolObservable = (()=>typeof Symbol === 'function' && Symbol.observable || '@@observable')();
const $7352d1cb7623abab$var$inspectionObservers = new WeakMap();
function $7352d1cb7623abab$var$createStoreCore(logic, emits) {
    let listeners;
    const initialSnapshot = logic.getInitialSnapshot();
    let currentSnapshot = initialSnapshot;
    const atom = $7352d1cb7623abab$export$f1e1789686576879(currentSnapshot);
    const emit = (ev)=>{
        if (!listeners) return;
        const type = ev.type;
        const typeListeners = listeners.get(type);
        if (typeListeners) typeListeners.forEach((listener)=>listener(ev));
    };
    const transition = logic.transition;
    function receive(event) {
        const [nextSnapshot, effects] = transition(currentSnapshot, event);
        currentSnapshot = nextSnapshot;
        $7352d1cb7623abab$var$inspectionObservers.get(store)?.forEach((observer)=>{
            observer.next?.({
                type: '@xstate.snapshot',
                event: event,
                snapshot: nextSnapshot,
                actorRef: store,
                rootId: store.sessionId
            });
        });
        atom.set(nextSnapshot);
        for (const effect of effects)if (typeof effect === 'function') effect();
        else {
            // handle the inherent effect first
            emits?.[effect.type]?.(effect);
            emit(effect);
        }
    }
    const store = {
        get _snapshot () {
            return atom._snapshot;
        },
        on (emittedEventType, handler) {
            if (!listeners) listeners = new Map();
            let eventListeners = listeners.get(emittedEventType);
            if (!eventListeners) {
                eventListeners = new Set();
                listeners.set(emittedEventType, eventListeners);
            }
            const wrappedHandler = handler.bind(undefined);
            eventListeners.add(wrappedHandler);
            return {
                unsubscribe () {
                    eventListeners.delete(wrappedHandler);
                }
            };
        },
        transition: logic.transition,
        // TODO: fix this
        sessionId: $7352d1cb7623abab$var$uniqueId(),
        send (event) {
            $7352d1cb7623abab$var$inspectionObservers.get(store)?.forEach((observer)=>{
                observer.next?.({
                    type: '@xstate.event',
                    event: event,
                    sourceRef: undefined,
                    actorRef: store,
                    rootId: store.sessionId
                });
            });
            receive(event);
        },
        getSnapshot () {
            return currentSnapshot;
        },
        get () {
            return atom.get();
        },
        getInitialSnapshot () {
            return initialSnapshot;
        },
        subscribe: atom.subscribe.bind(atom),
        [$7352d1cb7623abab$var$symbolObservable] () {
            return this;
        },
        inspect: (observerOrFn)=>{
            const observer = $7352d1cb7623abab$var$toObserver(observerOrFn);
            $7352d1cb7623abab$var$inspectionObservers.set(store, $7352d1cb7623abab$var$inspectionObservers.get(store) ?? new Set());
            $7352d1cb7623abab$var$inspectionObservers.get(store).add(observer);
            observer.next?.({
                type: '@xstate.actor',
                actorRef: store,
                rootId: store.sessionId
            });
            observer.next?.({
                type: '@xstate.snapshot',
                snapshot: initialSnapshot,
                event: {
                    type: '@xstate.init'
                },
                actorRef: store,
                rootId: store.sessionId
            });
            return {
                unsubscribe () {
                    return $7352d1cb7623abab$var$inspectionObservers.get(store)?.delete(observer);
                }
            };
        },
        trigger: new Proxy({}, {
            get: (_, eventType)=>{
                return (payload)=>{
                    store.send({
                        ...payload,
                        type: eventType
                    });
                };
            }
        }),
        select (selector, equalityFn = Object.is) {
            return $7352d1cb7623abab$export$f1e1789686576879(()=>selector(store.get().context), {
                compare: equalityFn
            });
        }
    };
    return store;
}
/**
 * Creates a **store** that has its own internal state and can be sent events
 * that update its internal state based on transitions.
 *
 * @example
 *
 * ```ts
 * const store = createStore({
 *   context: { count: 0, name: 'Ada' },
 *   on: {
 *     inc: (context, event: { by: number }) => ({
 *       ...context,
 *       count: context.count + event.by
 *     })
 *   }
 * });
 *
 * store.subscribe((snapshot) => {
 *   console.log(snapshot);
 * });
 *
 * store.send({ type: 'inc', by: 5 });
 * // Logs { context: { count: 5, name: 'Ada' }, status: 'active', ... }
 * ```
 *
 * @param config - The store configuration object
 * @param config.context - The initial state of the store
 * @param config.on - An object mapping event types to transition functions
 * @param config.emits - An object mapping emitted event types to handlers
 * @returns A store instance with methods to send events and subscribe to state
 *   changes
 */ function $7352d1cb7623abab$export$407448d2b89b1813(definitionOrLogic) {
    if ('transition' in definitionOrLogic) return $7352d1cb7623abab$var$createStoreCore(definitionOrLogic);
    const transition = $7352d1cb7623abab$export$db3b6bfb95261072(definitionOrLogic.on);
    const logic = {
        getInitialSnapshot: ()=>({
                status: 'active',
                context: definitionOrLogic.context,
                output: undefined,
                error: undefined
            }),
        transition: transition
    };
    return $7352d1cb7623abab$var$createStoreCore(logic, definitionOrLogic.emits);
}
function $7352d1cb7623abab$var$_createStoreConfig(definition) {
    return definition;
}
const $7352d1cb7623abab$export$4368d992c4eafac0 = $7352d1cb7623abab$var$_createStoreConfig;
/**
 * Creates a `Store` with a provided producer (such as Immer's `producer(…)` A
 * store has its own internal state and can receive events.
 *
 * @example
 *
 * ```ts
 * import { produce } from 'immer';
 *
 * const store = createStoreWithProducer(produce, {
 *   context: { count: 0 },
 *   on: {
 *     inc: (context, event: { by: number }) => {
 *       context.count += event.by;
 *     }
 *   }
 * });
 *
 * store.subscribe((snapshot) => {
 *   console.log(snapshot);
 * });
 *
 * store.send({ type: 'inc', by: 5 });
 * // Logs { context: { count: 5 }, status: 'active', ... }
 * ```
 */ function $7352d1cb7623abab$export$8b22cf2602fb60ce(producer, config) {
    const transition = $7352d1cb7623abab$export$db3b6bfb95261072(config.on, producer);
    const logic = {
        getInitialSnapshot: ()=>({
                status: 'active',
                context: config.context,
                output: undefined,
                error: undefined
            }),
        transition: transition
    };
    return $7352d1cb7623abab$var$createStoreCore(logic, config.emits);
}
/**
 * Creates a store transition function that handles state updates based on
 * events.
 *
 * @param transitions - An object mapping event types to transition functions
 * @param producer - Optional producer function (e.g., Immer's produce) for
 *   immutable updates
 * @returns A transition function that takes a snapshot and event and returns a
 *   new snapshot with effects
 */ function $7352d1cb7623abab$export$db3b6bfb95261072(transitions, producer) {
    return (snapshot, event)=>{
        const currentContext = snapshot.context;
        const assigner = transitions?.[event.type];
        const effects = [];
        const enqueue = {
            emit: new Proxy({}, {
                get: (_, eventType)=>{
                    return (payload)=>{
                        effects.push({
                            ...payload,
                            type: eventType
                        });
                    };
                }
            }),
            effect: (fn)=>{
                effects.push(fn);
            }
        };
        if (!assigner) return [
            snapshot,
            effects
        ];
        const nextContext = producer ? producer(currentContext, (draftContext)=>assigner(draftContext, event, enqueue)) : assigner(currentContext, event, enqueue) ?? currentContext;
        return [
            nextContext === currentContext ? snapshot : {
                ...snapshot,
                context: nextContext
            },
            effects
        ];
    };
}
/**
 * Generates a unique 6-character identifier.
 *
 * @returns A random string identifier
 */ function $7352d1cb7623abab$var$uniqueId() {
    return Math.random().toString(36).slice(6);
}
module.exports["e"] = $7352d1cb7623abab$export$f1e1789686576879;
module.exports["a"] = $7352d1cb7623abab$export$407448d2b89b1813;

});

parcelRegister("lbhE8", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9TRAA = parcelRequire("9TRAA");

function $f6b8503d65355db8$var$defaultCompare(a, b) {
    return a === b;
}
function $f6b8503d65355db8$var$identity(snapshot) {
    return snapshot;
}
function $f6b8503d65355db8$var$useSelectorWithCompare(selector, compare) {
    const previous = (0, $42omo.useRef)(undefined);
    return (snapshot)=>{
        const next = selector(snapshot);
        return previous.current && compare(previous.current, next) ? previous.current : previous.current = next;
    };
}
/**
 * A React hook that subscribes to the `store` and selects a value from the
 * store's snapshot, with an optional compare function.
 *
 * @example
 *
 * ```ts
 * function Component() {
 *   const count = useSelector(store, (s) => s.count);
 *
 *   return <div>{count}</div>;
 * }
 * ```
 *
 * @param store The store, created from `createStore(…)`
 * @param selector A function which takes in the `snapshot` and returns a
 *   selected value
 * @param compare An optional function which compares the selected value to the
 *   previous value
 * @returns The selected value
 */ function $f6b8503d65355db8$export$2105062e25df4afe(store, selector, compare = $f6b8503d65355db8$var$defaultCompare) {
    const selectorWithCompare = $f6b8503d65355db8$var$useSelectorWithCompare(selector, compare);
    return (0, $42omo.useSyncExternalStore)((0, $42omo.useCallback)((handleStoreChange)=>store.subscribe(handleStoreChange).unsubscribe, [
        store
    ]), ()=>selectorWithCompare(store.get()), ()=>selectorWithCompare(store.get()));
}
const $f6b8503d65355db8$export$6ccbb43953eebf8 = function useStoreImpl(definition) {
    const storeRef = (0, $42omo.useRef)(undefined);
    if (!storeRef.current) storeRef.current = (0, $9TRAA.a)(definition);
    return storeRef.current;
};
/**
 * A React hook that subscribes to the `atom` and returns the current value of
 * the atom.
 *
 * @example
 *
 * ```ts
 * const atom = createAtom(0);
 *
 * const Component = () => {
 *   const count = useAtom(atom);
 *
 *   return (
 *     <div>
 *       <div>{count}</div>
 *       <button onClick={() => atom.set((c) => c + 1)}>Increment</button>
 *     </div>
 *   );
 * };
 * ```
 *
 * @param atom The atom, created from `createAtom(…)`
 * @param selector An optional function which takes in the `snapshot` and
 *   returns a selected value
 * @param compare An optional function which compares the selected value to the
 *   previous value
 */ function $f6b8503d65355db8$export$83cf7ae8bb57e7ed(atom, selector = $f6b8503d65355db8$var$identity, compare = $f6b8503d65355db8$var$defaultCompare) {
    const state = $f6b8503d65355db8$export$2105062e25df4afe(atom, selector, compare);
    return state;
}
/**
 * Creates a custom hook that returns the selected value and the store from a
 * store configuration object.
 *
 * @example
 *
 * ```ts
 * const useCountStore = createStoreHook({
 *   context: { count: 0 },
 *   on: {
 *     inc: (context, event: { by: number }) => ({
 *       ...context,
 *       count: context.count + event.by
 *     })
 *   }
 * });
 *
 * function Component() {
 *   const [count, store] = useCountStore(s => s.context.count);
 *
 *   return (
 *     <div>
 *       {count}
 *       <button onClick={() => store.trigger.inc({ by: 1 })}>+</button>
 *     </div>
 *   );
 * }
 * ```
 *
 * @param definition The store configuration object
 * @returns A custom hook that returns [selectedValue, store]
 */ function $f6b8503d65355db8$export$671dba69185d0304(definition) {
    const store = (0, $9TRAA.a)(definition);
    function useStoreHook(selector, compare = $f6b8503d65355db8$var$defaultCompare) {
        // If no selector provided, return full snapshot
        if (!selector) {
            const snapshot = $f6b8503d65355db8$export$2105062e25df4afe(store, $f6b8503d65355db8$var$identity, $f6b8503d65355db8$var$defaultCompare);
            return [
                snapshot,
                store
            ];
        }
        // Use selector with comparison
        const selectedValue = $f6b8503d65355db8$export$2105062e25df4afe(store, selector ?? $f6b8503d65355db8$var$identity, compare);
        return [
            selectedValue,
            store
        ];
    }
    return useStoreHook;
}
module.exports["useAtom"] = $f6b8503d65355db8$export$83cf7ae8bb57e7ed;

});


//# sourceMappingURL=ObjectSidebarControl.e2bb65ee.js.map
